import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import LookbookGallery from '../Lookbook/LookbookGallery'

class LookbookSlice extends PureComponent {

    render() {
        const {item} = this.props;
        const {galleryImages} = item;
        return (
            <LookbookGallery key="temp" containerSize="medium" galleryImages={galleryImages} />
        );
    }
}

export default injectSheet(theme => ({

}))(LookbookSlice);



// WEBPACK FOOTER //
// ./src/components/Article/LookbookSlice.js